// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMarkdownLink-modulelink__amj95";
export { _1 as "link" }
